import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Box from 'grommet/components/Box'
import Hero from 'grommet/components/Hero'
import Heading from 'grommet/components/Heading'
import Image from 'grommet/components/Image'
import Paragraph from 'grommet/components/Paragraph'

import Footer from '../components/Footer'
import Header from '../components/Header'
import MenuItems from '../components/menus/MenuItems'
import BlowoutMenuItem from '../components/menus/BlowoutMenuItem'
import ActionLinks from '../components/ActionLinks'

import '../styles/OverviewMenu.css'
import '../styles/FourByFourMenu.css'
import '../styles/EightByThreeMenu.css'

class EightByThreeMenu extends Component {
  _renderBackgroundImage () {
    const {
      backgroundImage
    } = this.props.data

    if (backgroundImage) {
      return <Image src={backgroundImage} fit='cover' full />
    }
  }

  render () {
    const {
      history,
      data
    } = this.props

    const {
      title,
      backgroundImage,
      menuItems
    } = data

    let hasImageClass = backgroundImage ? 'has-image' : ''

    const menuCards = menuItems.filter((menuItem) => {
      return !menuItem.isSpecial
    })

    const menuCardsArray = []

    for (let i = 0; i < menuCards.length; i += 1) {
      if (i % 8 === 0) {
        menuCardsArray.push([])
      }

      menuCardsArray[menuCardsArray.length - 1].push(menuCards[i])
    }

    return (
      <div className={`OverviewMenu EightByThree ${hasImageClass} ${menuCards.length / 6 > 2 ? 'shorten-header' : ''}`}>
        <Hero background={backgroundImage ? this._renderHeroBackground() : null}>
          <Header
            bg={backgroundImage ? null : 'primary-1'}
            transparent />

          <Box align='center' style={{ marginTop: 18 }}>
            <Heading margin='none' strong>{title}</Heading>
            {this.subtitle()}
            {this.actionlinks()}
          </Box>
        </Hero>

        {menuCardsArray.map((menuCards, index) => {
          return (
            <div
              key={index}
              className='item-container enforce-margin' >
              <MenuItems menuItems={menuCards} itemComponent={BlowoutMenuItem} history={history} />
            </div>
          )
        })}

        <Footer
          isRoot={this.props.isRoot}
          history={history} />
      </div>
    )
  }

  _renderHeroBackground = () => {
    return (
      <div>
        <Image src={this.props.data.backgroundImage} fit='cover' full />
        <Image src='/images/inline/Overlay.png' className='overlay' />
      </div>
    )
  }

  headingOnly = () => {
    const {
      subtitle,
      actionLinks
    } = this.props.data

    if (!subtitle && actionLinks.length === 0) {
      return true
    }

    return false
  }

  subtitle = () => {
    const {
      subtitle
    } = this.props.data

    if (subtitle) {
      return (
        <Paragraph align='center' size='large'>{subtitle}</Paragraph>
      )
    }

    return null
  }

  actionlinks = () => {
    const {
      actionLinks
    } = this.props.data

    if (actionLinks) {
      return (
        <ActionLinks links={actionLinks} history={this.props.history} />
      )
    }

    return null
  }
}

EightByThreeMenu.propTypes = {
  data: PropTypes.object,
  history: PropTypes.object,
  isRoot: PropTypes.bool
}

export default EightByThreeMenu



// WEBPACK FOOTER //
// ./src/layouts/EightByThreeMenu.js